import * as React from 'react';
import {connect} from 'react-redux';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {withTranslation} from 'react-i18next';
import * as Dictionary from 'Models/Dictionary';
import {
    ParentDetails,
    IParentDetailsProps,
    CustomProps,
    ParentDetailsTypeEnum
} from 'components/Layout/DetailsSidebar/ParentDetails';
import {ActionDetailsIcon} from "HelperFunctions/DetailsSidebarHelpers";
import {submit} from "redux-form";
import * as VehiclesModule from "Modules/VehiclesModule";

interface IP extends IParentDetailsProps {
    edit: boolean;
    match?: any;
}

interface IConnectedP {
    activeVehicleDetails: VehiclesModule.Types.CarDto;
}

interface IDispatchedP {
    t?: (key: string) => string;
    turnOnCar: (carId: number) => void;
    sendFormSubmit: () => void;
}

type S = {};

export class TurnOffCarDetails extends ParentDetails<IP & IConnectedP & IDispatchedP, S> {
    constructor(props: IP & IConnectedP & IDispatchedP) {
        super(props);
    }

    public getCustomProps(): CustomProps {
        const {CARS_MANAGEMENT} = ViewManagementModule.EnumTypes.Page;

        return {
            ...(this.props as any),
            redirectUrlList: Dictionary.PageUrl.get(CARS_MANAGEMENT),
            type: ParentDetailsTypeEnum.SIDEBAR_ONE_ELEMENT
        };
    }

    protected sendForm() {
        // this.props.sendFormSubmit();
    }

    public render() {
        const {t, sendFormSubmit, activeVehicleDetails, turnOnCar} = this.props;
        return <div className="details-right__dashboard">
            {activeVehicleDetails?.turnOffDate ?
                <>
                    <ActionDetailsIcon active iconSrc={`/images/icons/save.svg`} title={t('turnOnCarAgain')}
                                       e2eId={"saveBtn"} onClick={() => turnOnCar(activeVehicleDetails.id)}/>

                    <ActionDetailsIcon active iconSrc={`/images/icons/status_queue.svg`} title={t('Wróc do listy pojazdów')}
                                       e2eId={"cancelBtn"} onClick={() => this.cancelClick()}/>
                </> :
                <>
                    <ActionDetailsIcon active iconSrc={`/images/icons/save.svg`} title={t('forms:send')}
                                       e2eId={"saveBtn"} onClick={sendFormSubmit}/>

                    <ActionDetailsIcon active iconSrc={`/images/icons/red_cros.svg`}
                                       title={t('forms:cancel')}
                                       e2eId={"cancelBtn"} onClick={() => this.cancelClick()}/>
                </>
            }
        </div>
    }
}

function mapStateToProps(state: any): IConnectedP {
    return {
        activeVehicleDetails: state.vehiclesStore.activeVehicleDetails,
    };
}

function mapDispatchToProps(dispatch: any): IDispatchedP {
    return {
        turnOnCar: (carId: number) => dispatch(VehiclesModule.Actions.turnOnCar(carId)),
        sendFormSubmit: () => dispatch(submit('ChangeDateForm'))
    }
}

export default withTranslation(['carDetails', 'forms'])(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(TurnOffCarDetails) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/CarsManagement/TurnOffCarDetails.tsx